import type { ReactNode } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

/**
 * Standard wrapper for the filters region of a dashboard. Use as the first
 * card on every dashboard so layout, spacing and the "Filtre" header stay
 * consistent across dashboards.
 *
 * The contents are arbitrary JSX — typically date pickers + a text search
 * + quick-button chips. See `discount-codes.tsx` for a canonical layout.
 */
export function FiltersCard({
  title = "Filtre",
  children,
}: {
  title?: string;
  children: ReactNode;
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm font-medium text-admin-text-secondary">
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">{children}</CardContent>
    </Card>
  );
}
